import r2wc from "@r2wc/react-to-web-component";

import { YourTeam } from "@percy.ai/ui";

const YourTeamComponent = r2wc(YourTeam, {
  props: {
    header: "string",
    team: "json",
    socialNetworksColor: "string",
  },
});

if (customElements) {
  customElements.define("your-team", YourTeamComponent);
}
